import { render } from "./PaymentBank.vue?vue&type=template&id=5fd92ed6&scoped=true"
import script from "./PaymentBank.vue?vue&type=script&lang=js"
export * from "./PaymentBank.vue?vue&type=script&lang=js"

import "./PaymentBank.vue?vue&type=style&index=0&id=5fd92ed6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd92ed6"]])

export default __exports__